import { render, staticRenderFns } from "./TiposCreditoCRUD.vue?vue&type=template&id=2aca4f24"
import script from "./TiposCreditoCRUD.vue?vue&type=script&lang=js"
export * from "./TiposCreditoCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports